// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "错误代码：",
    "error.search": "搜索我们的知识库以了解详情",
    dismiss: "撤销",
    "installation.title": "",
    "cancelation.button": "取消",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "初始化失败",
      description: "我们无法渲染页面。请联系支持部门。",
    },
    "EOS-UI-UE": {
      title: "出错了。",
      description: "出错了。请联系支持部门。",
    },
    "EOS-IN-BC": {
      title: "初始化失败",
      description: "我们无法显示安装进度。请联系支持部门。",
    },
    "EOS-IN-UE": {
      title: "安装失败",
      description: "出错了。请联系支持部门。",
    },
    "EOS-IN-FF": {
      title: "安装失败",
      description: "我们无法连接到Epic在线服务。请联系支持部门。",
    },
    "EOS-IN-FF-*": {
      title: "安装失败",
      description: "我们无法执行给Epic在线服务的请求。请联系支持部门。",
    },
    fallback: {
      title: "出错了。",
      description: "出错了。请联系支持部门。",
    },
  },
};
